import React from "react";

const Content = ({ className, Component, exit, isModal }) => (
  <div className={className}>
    {console.log("here before component")}
    <Component exit={exit} isModal={isModal} />
  </div>
);

Content.defaultProps = {
  className: "bg-white w-full flex-1 relative z-20 px-4 py-8"
};

export default Content;
